import { AUTHENTICATION_SERVICE } from 'api/constants';
import { createGetEndpoint } from 'api/utils';
import {
  FORGOT_PASSWORD_PATH,
  LOGIN_PATH,
  REGISTER_USER_PATH,
  RESET_PASSWORD_PATH,
} from './constants';

const PATHS_BY_NAME = {
  forgotPassword: FORGOT_PASSWORD_PATH,
  login: LOGIN_PATH,
  register: REGISTER_USER_PATH,
  resetPassword: RESET_PASSWORD_PATH,
};

export const getAuthEndpoint = createGetEndpoint(
  AUTHENTICATION_SERVICE,
  PATHS_BY_NAME,
);
